import { render, staticRenderFns } from "./ModalSuporteProcedimentoApenasHospitalDia.vue?vue&type=template&id=2c74f5c1&scoped=true"
import script from "./ModalSuporteProcedimentoApenasHospitalDia.vue?vue&type=script&lang=ts"
export * from "./ModalSuporteProcedimentoApenasHospitalDia.vue?vue&type=script&lang=ts"
import style0 from "./ModalSuporteProcedimentoApenasHospitalDia.vue?vue&type=style&index=0&id=2c74f5c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c74f5c1",
  null
  
)

export default component.exports